import { RemoteComponent } from 'mf-dynamic-remote-component';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Spinner, GridColumn, Grid, Notice, Button, Separator } from 'telia-front-react';
const SsoDropdownContent = ({ url, rootStore }) => {
    const { tier, ssoBackendURL, brand } = rootStore.environmentStore;
    const { client } = rootStore.ssoStore;
    const { translate } = rootStore.translationsStore;
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setError] = useState(false);
    const [App, setApp] = useState(null);
    useEffect(() => {
        loadRemoteApp();
    }, []);
    const loadRemoteApp = async (bustCache = false) => {
        setIsLoading(true);
        setError(false);
        setApp(null);
        try {
            const remoteApp = await RemoteComponent({
                path: `${ssoBackendURL}/js/sso-remote.js${bustCache ? `?cb=${Date.now()}` : ''}`,
                scope: 'sso',
                module: './App',
            });
            setApp(() => remoteApp.default);
        }
        catch (e) {
            console.error('ErrorBoundary caught an error:', e);
            setError(true);
        }
        finally {
            setIsLoading(false);
        }
    };
    const handleRetryClick = async (event) => {
        event.preventDefault();
        await loadRemoteApp(true);
    };
    const ssoConfig = {
        brand: brand,
        apiUrl: `${ssoBackendURL}/api`,
        env: tier,
    };
    if (isLoading) {
        return (React.createElement(Grid, { style: { minHeight: '400px', marginRight: 0, marginBottom: 0 }, align: ['center-xs'], className: "text-center" },
            React.createElement(GridColumn, { align: ['middle-xs'] },
                React.createElement(Spinner, null))));
    }
    if (isError || !App) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { color: "invisible", spacing: "medium" }),
            React.createElement(Notice, { type: "error" },
                React.createElement(Grid, null,
                    React.createElement(GridColumn, null,
                        React.createElement("p", null, translate('general.error.message'))),
                    React.createElement(GridColumn, null,
                        React.createElement(Button, { size: "small", iconRight: "#arrow-right", text: translate('general.tryAgain'), onClick: handleRetryClick }))))));
    }
    return React.createElement(App, { initialUrl: url, config: { ...ssoConfig, env: tier }, client: client });
};
export default observer(SsoDropdownContent);
//# sourceMappingURL=SsoModule.js.map